// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1IMzv","header":"Messages_header__1OpH5"};